import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-contrast cursor-pointer tracking-wider'
  }
});
